import React from 'react'
import { CSSTransition } from 'react-transition-group'
import { FormattedMessage } from 'react-intl'
import ZH_Options from '../locale/zh_options'
import EN_Options from '../locale/en_options'
import JA_Options from '../locale/ja_options'
import './aside.css'

function init_option(data) {
  let array = []
  for (let item of data) {
    const style = item.key === 'all' || item.key.substr(0, 2) === 'c_'
      ? {fontWeight: 'bold', fontSize: '14px', background: '#ddeeff'} : {}
    array.push(
      <option className='aside-option-item' key={item.key} value={item.key}
      style={style}>{item.value}</option>
    )
  }
  return array
}

var inputs = {
  rarity: null,
  effect: null,
  condition: null,
  exclusive: null,
  type: null,
  name: null
}

function Aside(props) {
  let options
  if (props.locale.match(/^zh/i))
    options = ZH_Options
  else if (props.locale.match(/^ja/i))
    options = JA_Options
  else
    options = EN_Options

  return (
    <CSSTransition classNames='aside' in={props.active} timeout={300}>
      <div className='aside' >
        <AsideSelects label='rarity' input='rarity' list={init_option(options.rarity)}/>
        <AsideSelects label='ability' input='effect' list={init_option(options.effect)}/>
        <AsideSelects label='condition' input='condition' list={init_option(options.condition)}/>
        <AsideSelects label='exclusive' input='exclusive' list={init_option(options.exclusive)}/>
        <AsideSelects label='availability' input='type' list={init_option(options.type)}/>
        <div className='aside-item'>
          <div className='aside-label'><FormattedMessage id="name"/> / ID</div>
          <input className="aside-input-item" ref={input => inputs.name = input}></input>
        </div>
        <div className='aside-button-div'>
          <button className='aside-button' onClick={() => {
            props.handleSubmit(getInputsData(inputs))
            props.handleClose(false)
          }}><FormattedMessage id="search"/></button>
          <button className='aside-button' onClick={() => {
            clear()
          }} style={{float: 'right'}}><FormattedMessage id="clear"/></button>
        </div>
      </div>
    </CSSTransition>
  )
}

function AsideSelects(props) {
  return(
    <div className='aside-item'>
      <div className='aside-label'><FormattedMessage id={props.label}/></div>
      <select className="aside-input-item" ref={i => inputs[props.input] = i}>
        {props.list}
      </select>
    </div>
  )
}

function getInputsData(inputs) {
  let data = {}
  let keys = Object.keys(inputs)
  let values = Object.values(inputs)
  for (let i = 0; i < keys.length; i++) {
    data[keys[i]] = values[i].value
  }
  return data
}

function clear() {
  inputs.rarity.value = 'all'
  inputs.effect.value = 'all'
  inputs.condition.value = 'all'
  inputs.exclusive.value = 'all'
  inputs.type.value = 'all'
  inputs.name.value = ''
}

export default Aside